import { ReducerCommandType } from "../Types";
import { localStore } from "../io/localStore";

// ----------------------- Events -----------------------
const CHANGE_USER_RESET = "CHANGE_USER_RESET";
const CHANGE_USER_LOGIN_TOKEN = "CHANGE_USER_LOGIN_TOKEN";
const CHANGE_USER_INFO = "CHANGE_USER_INFO";

// ----------------------- Types -----------------------
// Reducer
export type languageType = "en" | "sv";
export type UserReducerType = {
    user: UserInfoType | undefined | null,
    loginToken: string | undefined | null,
}

// Other types
export type UserInfoType = {
    id: string,
    name: string,
    email: string,
    avatarId: string,
    organizationRoles: string[],
    selectedOrganizationId: string,
    profileimage: string
    roles: SystemRolesType[],
    products: string[]
}
export type UserRoleType = "ORGANIZATION_OWNER" | "ORGANIZATION_MEMBER";
export type SystemRolesType = "ORGANIZATIONADMINISTRATOR" | "DEVELOPER"
// ----------------------- DefaultState -----------------------
const userReducerDefaultState: UserReducerType = {
    user: undefined,
    loginToken: undefined
};

// ----------------------- Reducer -----------------------
const userReducer = (state = {
    ...userReducerDefaultState
}, action: ReducerCommandType) => {
    switch (action.type) {
        case CHANGE_USER_RESET: { state = { ...userReducerDefaultState }; break; }
        case CHANGE_USER_LOGIN_TOKEN: { state = { ...state, loginToken: action.payload }; break; }
        case CHANGE_USER_INFO: { state = { ...state, user: action.payload }; break; }

        default: { return state; }
    }
    return state;
};

// ----------------------- Export -----------------------
export {
    userReducer,
    CHANGE_USER_RESET,
    CHANGE_USER_LOGIN_TOKEN,
    CHANGE_USER_INFO,
}